import { Labeled, ReferenceArrayField, SimpleShowLayout, SingleFieldList } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { SectionTitle } from "features/SectionTitle";
import { paymentRequests } from "api/paymentApi";
const IbansField = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="IBANS"
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Labeled label="Iban">
            <ReferenceArrayField
              source="ibanIds"
              reference={paymentRequests.getIbansSelect()}
            >
              <SingleFieldList
                linkType={false}
                label="Iban"
                source="name"
                empty={"-"}
              />
            </ReferenceArrayField>
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};
export default IbansField;
